import { computed } from '@vue/composition-api'
import store from '@/store'

export default () => {
  const computedData = {
    // 兑换状态
    AWARDS_IS_EXCHANGE: computed(() => (
      store.state.label.data.AWARDS?.AWARDS_IS_EXCHANGE
    )),
    // 七牛域名
    QI_NIU_DOMAINS: computed(() => (
      store.state.label.data.QI_NIU_DOMAINS
    ))
  }

  function showName(type, id) {
    const item = computedData[type].value.filter(item => item.key === id)[0]
    return (item && item.value) || '--'
  }

  return {
    ...computedData,
    showName
  }
}
